import { Datalayer, groupBy, IOmniaShell } from "../../omnia"

export function validateLayer(layer: Datalayer, shell: IOmniaShell) {

    if (!layer.type) {
        return false
    }

    if (layer.type.ZoneNumbersReadOnly) {
        return true
    }

    if (!validateRequiredZoneNumbers(layer, shell)) {
        return false
    }

    if (!validateUniqueZoneNumbers(layer, shell)) {
        return false
    }

    return true

}


function validateRequiredZoneNumbers(layer: Datalayer, shell: IOmniaShell) {

    const { zones } = layer
    if (!zones) return true

    let missing = zones.filter(z => (z.zoneNumber || 0) <= 0);
    if (!missing.length) return true;

    const msg = "<p>This layer contains zones with no zone number set. Please set a zone number for each zone in this layer and try saving again.</p>";
    const title = "Missing zone numbers"

    omnia.shell.showWarning(shell, msg, title);

    return false;

}

function validateUniqueZoneNumbers(layer: Datalayer, shell: IOmniaShell) {

    const { zones } = layer
    if (!zones) return true

    let groups = groupBy(zones, z => z.zoneNumber).filter(g => g.values.length > 1);
    if (!groups.length) return true;

    const numbers = "<ul>" + groups.map(g => `<li>- ${g.key.toString()}<li>`).join("") + "</ul>";

    const msg = `<p>The following zone numbers are used on multiple zones. Please make sure that each zone has a unique number, and try saving again.</p><p>Duplicate zone numbers:</p>${numbers}`
    const title = "Duplicate zone numbers"

    omnia.shell.showWarning(shell, msg, title);

    return false;

}
